export class CustomTrash implements mapboxgl.IControl {
  _map: mapboxgl.Map | undefined;

  _container: HTMLElement | undefined;

  _delete: () => void;

  constructor(f: () => void) {
    this._delete = f;
  }

  onAdd(map: mapboxgl.Map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
    const button = this._createButton('mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_trash');
    this._container.appendChild(button);
    return this._container;
  }

  onRemove() {
    this._container?.parentNode?.removeChild(this._container);
    this._map = undefined;
  }

  _createButton(className: string) {
    const button = document.createElement('button');
    button.className = className;
    button.setAttribute('title', 'Delete');
    button.addEventListener(
      'click',
      (e) => {
        e.stopPropagation();
        this._delete();
      },
      false,
    );
    return button;
  }
}
